import { IApplicationState } from '../../types/redux';

export function getNewbuildingIdsForBuildersPromoSlider({ offersData }: IApplicationState) {
  return offersData.newbuildingIdsForBuildersPromoSlider;
}
